import Crud from './crud'

var crud = new Crud('system_logs', 'nhật ký hệ thống');

const state = {
    ...crud.state,
    selected: { id: 0 }
};

const getters = { ...crud.getters };
const actions = { ...crud.actions };
const mutations = { ...crud.mutations };

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
